/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderDailyStatsResponseSchema } from "./mobileOrderDailyStatsResponseSchema.ts";

export const orderDailyStatsRetrieveQueryDateFromSchema = z.iso.date();

export const orderDailyStatsRetrieveQueryDateToSchema = z.iso.date();

export const orderDailyStatsRetrieveStatus200Schema = mobileOrderDailyStatsResponseSchema;

export const orderDailyStatsRetrieveResponseSchema = orderDailyStatsRetrieveStatus200Schema;
